export default __webpack_public_path__ + "static/media/btn-play-rounded.dab7057a.svg";